<template>
  <el-row
      type="flex"
      align="middle"
      class="info-wrapper">
    <div class="info--image">
      <gj-image
          :src="item.imageUrl"
          :size="90"></gj-image>
    </div>
    <div class="right__wrapper">
      <el-row
          type="flex"
          class="info__base">
        <div class="info__base--title text-ellipsis-2">{{item.title}}</div>
        <div v-gutter="8"
             class="info__base--tag">
          <gj-tag
              v-if="item.operationStatus"
              shape="rectangle"
              color="#5BBD2A">
            {{item.operationStatus}}
          </gj-tag>
        </div>
      </el-row>
      <div class="info__other">
        <div class="info__other--first">
          <el-row>
            <el-col :span="5">
              <span class="gj-label">店铺/国家：</span><span class="gj-content">{{  isMeaningful(marketMap[item.marketId]) ? marketMap[item.marketId].text : '-' }}</span>
            </el-col>
            <el-col :span="5">
              <span class="gj-label">ASIN：</span><span class="gj-content">{{ item.asin | defaultShow }}</span>
            </el-col>
            <el-col :span="4">
              <span class="gj-label">父ASIN：</span><span class="gj-content">{{ item.variationAsin | defaultShow }}</span>
            </el-col>
          </el-row>
        </div>
        <div class="info__other--second">
          <el-row>
            <el-col :span="5">
              <span class="gj-label">MSKU：</span><span class="gj-content">{{ item.msku | defaultShow }}</span>
            </el-col>
            <el-col :span="5">
              <span class="gj-label">售价：</span><span class="gj-content">{{ item.salePrice | defaultShow(currencySymbol) }}</span>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </el-row>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {isMeaningfulMixin} from "../../../../../../minxins";
  
  export default {
    name: "app-listing-info",
    mixins: [isMeaningfulMixin],
    props: {
      marketId: {
        required: true,
      },
      currencySymbol: {
        required: true,
      },
      item: {
        required: true
      }
    },
    computed: {
      ...mapGetters({
        marketMap: 'marketMap',
      })
    }
  }
</script>

<style lang="scss" scoped>
  .info-wrapper {
    margin-bottom: 8px;
  }
  .info--image {
    margin-right: 20px;
  }
  .right__wrapper {
    flex: 1;
  }
  .info__base {
  
  }
  .info__base--title {
    max-width: 1000px;
    color: #333;
    font-weight: bold;
  }
  .info__base--tag {
    margin-left: 10px;
  }
  .info__other {
    margin-top: 12px;
  }
  .info__other--first {
    margin-bottom: 8px;
  }
  .info__other--second {
  
  }
  .rate {
    display: inline-block;
  }
  .rate-score {
    margin: 0 5px;
  }
  /deep/ .gj-label, /deep/ .gj-content{
    font-size: 13px;
  }
</style>
